module.exports = __webpack_public_path__ + "img/1588025628.b24ff8cd.jpg";